module.exports = __webpack_public_path__ + "img/tu05.56d9f29e.jpg";